import { render, staticRenderFns } from "./CurrentLpo__tax.vue?vue&type=template&id=3a94e679&scoped=true&"
import script from "./CurrentLpo__tax.vue?vue&type=script&lang=js&"
export * from "./CurrentLpo__tax.vue?vue&type=script&lang=js&"
import style0 from "@/style/table.css?vue&type=style&index=0&id=3a94e679&scoped=true&lang=css&"
import style1 from "./CurrentLpo__tax.vue?vue&type=style&index=1&id=3a94e679&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a94e679",
  null
  
)

export default component.exports